import React from 'react';
import styles from "./Table.module.css";

const Table = ({
  users,
  groups,
  filter,
  setMid,
  mid
}) => {
  if (!users || users.length === 0) return null;

  const detailTitles = users[0]?.[0]?.details?.map(d => d.first_level_title) || [];

  return (
    <div className={styles.table}>
      <table>
        <tbody>
          <tr className={styles.tableHead} style={{ position: 'sticky', top: '-1px' }}>
            <td style={{ width: '50px' }}>№ п/п</td>
            <td style={{ width: '350px' }}>Фамилия И.О. (учебная группа)</td>
            {detailTitles.map((title, idx) => (
              <td key={idx}>{title}</td>
            ))}
            <td>Сумма баллов</td>
            <td className={styles.placeDigital}>Место</td>
          </tr>

          {users
            .sort((a, b) => (parseFloat(b[0]?.final_point || 0) - parseFloat(a[0]?.final_point || 0)))
            .map((user, index) => (
              <tr
                key={`${user[0].id}_${index}`}
                className={`${mid === user[0].mid ? styles.tableRowActive : styles.tableRow}`}
                onClick={() => setMid(user[0].mid)}
              >
                <td>{index + 1}</td>
                <td className={styles.namesDigital}>
                  &ensp;&ensp;
                  {`${user[0].lastname || ''} ${user[0].firstname || ''} ${user[0].patronymic || ''} 
                    (${groups.find(gr => gr.gid == filter.g)?.name || ''})`}
                </td>

                {detailTitles.map((title, idx) => {
                  const detail = user[0].details.find(d => d.first_level_title === title);
                  const points = detail?.last_level_points;
                  return (
                    <td key={idx} className={styles.listTd}>
                      {points > 0 ? Math.floor(parseFloat(points).toFixed(3) * 1000) / 1000 : ''}
                    </td>
                  );
                })}

                <td>
                  {user[0]?.final_point ? parseFloat(user[0].final_point).toFixed(3) : ''}
                </td>
                <td>{index + 1}</td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
